import { bulandiSubEvents } from "../../data/bulandi2026Data";
import {
  bulandiGroupEventTeammateSlots,
  bulandiIsGroupEventForRegistration,
} from "../../data/bulandiGroupEventRegistration";
import { eventRegistrationTierFromBrNumeric } from "../../utils/bulandiRegistrationSheet";

export { bulandiGroupEventTeammateSlots, bulandiIsGroupEventForRegistration };

export const eventsJuniors = bulandiSubEvents.filter((e) => e.ageTier === "juniors");
export const eventsIntermediates = bulandiSubEvents.filter(
  (e) => e.ageTier === "intermediates",
);
export const eventsSeniorsOnly = bulandiSubEvents.filter(
  (e) => e.ageTier === "seniors",
);
export const eventsFamilyOnly = bulandiSubEvents.filter((e) => e.ageTier === "family");

/** Seniors competitions plus the family game show (registration bucket for 16+ DOB). */
export const eventsSeniorsFamily = bulandiSubEvents.filter(
  (e) => e.ageTier === "seniors" || e.ageTier === "family",
);

/** All youth-band events (Juniors + Intermediates) — used for admin B-number B1001–B2999 column matching. */
export const eventsUnder15 = bulandiSubEvents.filter((e) => e.ageGroup === "under15");
/** Seniors + family — B3001+ admin bucket. */
export const eventsOver15 = bulandiSubEvents.filter((e) => e.ageGroup === "over15");

export const BULANDI_PAGE_TABS = [
  { id: "home", label: "Home" },
  { id: "bulandi-registration", label: "Registration" },
  { id: "events", label: "Events" },
  { id: "event-registration", label: "Events Sign In" },
  { id: "workshop-registration", label: "Workshops" },
  { id: "sponsors", label: "Sponsors" },
];

export const BULANDI_VALID_TAB_IDS = new Set(BULANDI_PAGE_TABS.map((t) => t.id));

/** First tab in `BULANDI_PAGE_TABS` when the URL has no valid hash. */
export const BULANDI_DEFAULT_TAB_ID = BULANDI_PAGE_TABS[0].id;

export function readBulandiTabFromHash() {
  if (typeof window === "undefined") return BULANDI_DEFAULT_TAB_ID;
  const raw = window.location.hash.replace(/^#/, "").trim();
  return BULANDI_VALID_TAB_IDS.has(raw) ? raw : BULANDI_DEFAULT_TAB_ID;
}

/**
 * Eligible competition list after DOB validation.
 * @param {'juniors' | 'intermediates' | 'seniors' | null} tier
 */
export function eventsForBulandiDobTier(tier) {
  if (tier === "juniors") return eventsJuniors;
  if (tier === "intermediates") return eventsIntermediates;
  if (tier === "seniors") return eventsSeniorsFamily;
  return [];
}

/**
 * Event Registration tab: catalogue from B No.. Family game show only when B is above 1500 (not for juniors B1001–B1499).
 * @param {number | null} brNumeric from {@link parseBrNumeric}
 */
export function eventsForEventRegistrationByBr(brNumeric) {
  const tier = eventRegistrationTierFromBrNumeric(brNumeric);
  if (!tier) return [];
  const includeFamily = brNumeric != null && brNumeric > 1500;
  if (tier === "juniors") return [...eventsJuniors];
  if (tier === "intermediates")
    return includeFamily
      ? [...eventsIntermediates, ...eventsFamilyOnly]
      : [...eventsIntermediates];
  if (tier === "seniors")
    return includeFamily ? [...eventsSeniorsFamily] : [...eventsSeniorsOnly];
  return [];
}
